var recaptchaOnloadCallback = function() {
    grecaptcha.render('g-recaptcha', {
        'sitekey' : recaptchaKey
    });
};

function openProductsMenu() {
    var eventClick = new Event('click');
    document.getElementById('link_1').dispatchEvent(eventClick);
}